// AUTO-GENERATED by scripts/gen-levels.ts — do not edit by hand.
// 80 procedurally generated, simulator-validated unique-solution levels.
// Regenerate with: npx tsx scripts/gen-levels.ts
import type { LevelDef } from '../sim/types';

export const GENERATED_LEVELS: LevelDef[] = [
  {
    id: 'g1',
    name: "Cinder",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"x1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'g2',
    name: "Vault",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"},
    {"id":"x2","x":420,"y":680,"type":"normal","label":"X2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"x1","type":"directional"},
    {"id":"w2","a":"s3","b":"x2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'g3',
    name: "Specter",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":900,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g4',
    name: "Halcyon",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"},
    {"id":"x2","x":420,"y":680,"type":"normal","label":"X2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"x1","type":"directional"},
    {"id":"w2","a":"s3","b":"x2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'g5',
    name: "Quartz",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"x1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'g6',
    name: "Vector",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"},
    {"id":"x2","x":420,"y":680,"type":"normal","label":"X2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"x1","type":"directional"},
    {"id":"w2","a":"s3","b":"x2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'g7',
    name: "Onyx",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":900,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"r1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g8',
    name: "Pylon",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":900,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"x1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'g9',
    name: "Cascade",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"},
    {"id":"x2","x":420,"y":680,"type":"normal","label":"X2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"x1","type":"directional"},
    {"id":"w2","a":"s3","b":"x2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'g10',
    name: "Ledger",
    tier: 'beginner',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"},
    {"id":"x2","x":420,"y":680,"type":"normal","label":"X2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"x1","type":"directional"},
    {"id":"w2","a":"s3","b":"x2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'g11',
    name: "Mirage",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"r1","type":"directional"},
    {"id":"w1","a":"s3","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"p1","type":"directional"},
    {"id":"w3","a":"s2","b":"r1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g12',
    name: "Bastion",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r1","type":"directional"},
    {"id":"w3","a":"s3","b":"r2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g13',
    name: "Cipher",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":900,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g14',
    name: "Lattice",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g15',
    name: "Nexus",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":900,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g16',
    name: "Falter",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r1","type":"directional"},
    {"id":"w3","a":"s3","b":"r2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g17',
    name: "Static",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":900,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g18',
    name: "Ember",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"p1","type":"directional"},
    {"id":"w3","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g19',
    name: "Drift",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"p1","type":"directional"},
    {"id":"w3","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g20',
    name: "Conduit",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"r1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g21',
    name: "Fracture",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"r1","type":"directional"},
    {"id":"w1","a":"s3","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r1","type":"directional"},
    {"id":"w3","a":"s2","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g22',
    name: "Helix",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"p1","type":"directional"},
    {"id":"w3","a":"s3","b":"r1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g23',
    name: "Voltage",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r3","type":"directional"},
    {"id":"w3","a":"s2","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g24',
    name: "Sever",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r3","type":"directional"},
    {"id":"w3","a":"s2","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g25',
    name: "Tessel",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":660,"y":1580,"type":"required","label":"R3"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r3","type":"directional"},
    {"id":"w3","a":"s2","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g26',
    name: "Gambit",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g27',
    name: "Ridge",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s2","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g28',
    name: "Pulse",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":420,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g29',
    name: "Threshold",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g30',
    name: "Aperture",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":420,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s2","b":"r3","type":"directional"},
    {"id":"w4","a":"s1","b":"p1","type":"directional"},
    {"id":"w5","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g31',
    name: "Echo",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s2","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g32',
    name: "Relay",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"p1","type":"directional"},
    {"id":"w3","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g33',
    name: "Cinder",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":900,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g34',
    name: "Vault",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g35',
    name: "Specter",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"r3","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g36',
    name: "Halcyon",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"r1","type":"directional"},
    {"id":"w1","a":"s3","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"p1","type":"directional"},
    {"id":"w3","a":"s2","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g37',
    name: "Quartz",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"r1","type":"directional"},
    {"id":"w1","a":"s3","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"p1","type":"directional"},
    {"id":"w3","a":"s2","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g38',
    name: "Vector",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w4","a":"s3","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g39',
    name: "Onyx",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":660,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":900,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"r3","type":"directional"},
    {"id":"w4","a":"s1","b":"p1","type":"directional"},
    {"id":"w5","a":"s2","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g40',
    name: "Pylon",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"r1","type":"directional"},
    {"id":"w1","a":"s3","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w3","a":"s2","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g41',
    name: "Cascade",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"r3","type":"directional"},
    {"id":"w4","a":"s1","b":"r3","type":"forbidden"},
    {"id":"w5","a":"s2","b":"r3","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g42',
    name: "Ledger",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"r1","type":"directional"},
    {"id":"w1","a":"s3","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w3","a":"s2","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g43',
    name: "Mirage",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":900,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w4","a":"s3","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g44',
    name: "Bastion",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w4","a":"s2","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g45',
    name: "Cipher",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"r3","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"r3","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g46',
    name: "Lattice",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"r3","type":"directional"},
    {"id":"w4","a":"s2","b":"p1","type":"directional"},
    {"id":"w5","a":"s3","b":"r3","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g47',
    name: "Nexus",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"r3","type":"directional"},
    {"id":"w4","a":"s1","b":"r2","type":"forbidden"},
    {"id":"w5","a":"s2","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g48',
    name: "Falter",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"forbidden"},
    {"id":"w3","a":"s3","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g49',
    name: "Static",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"r1","type":"directional"},
    {"id":"w1","a":"s3","b":"r2","type":"directional"},
    {"id":"w2","a":"s3","b":"r3","type":"directional"},
    {"id":"w3","a":"s1","b":"r2","type":"forbidden"},
    {"id":"w4","a":"s2","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g50',
    name: "Ember",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":420,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"p1","x":180,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g51',
    name: "Drift",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"sh","type":"directional"},
    {"id":"w3","a":"s2","b":"r2","type":"delay"},
    {"id":"w4","a":"s1","b":"p1","type":"directional"},
    {"id":"w5","a":"s3","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g52',
    name: "Conduit",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r3","type":"directional"},
    {"id":"w3","a":"s1","b":"sh","type":"directional"},
    {"id":"w4","a":"s1","b":"r3","type":"delay"},
    {"id":"w5","a":"s2","b":"r1","type":"forbidden"},
    {"id":"w6","a":"s3","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g53',
    name: "Fracture",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"r3","type":"directional"},
    {"id":"w4","a":"s3","b":"sh","type":"directional"},
    {"id":"w5","a":"s3","b":"r3","type":"delay"},
    {"id":"w6","a":"s1","b":"p1","type":"directional"},
    {"id":"w7","a":"s2","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g54',
    name: "Helix",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"r3","type":"directional"},
    {"id":"w4","a":"s1","b":"sh","type":"directional"},
    {"id":"w5","a":"s1","b":"r3","type":"delay"},
    {"id":"w6","a":"s2","b":"p1","type":"directional"},
    {"id":"w7","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g55',
    name: "Voltage",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"r3","type":"directional"},
    {"id":"w4","a":"s3","b":"sh","type":"directional"},
    {"id":"w5","a":"s3","b":"r3","type":"delay"},
    {"id":"w6","a":"s1","b":"r2","type":"forbidden"},
    {"id":"w7","a":"s2","b":"r3","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g56',
    name: "Sever",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"sh","type":"directional"},
    {"id":"w4","a":"s1","b":"r2","type":"delay"},
    {"id":"w5","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w6","a":"s3","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g57',
    name: "Tessel",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":660,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s2","b":"r3","type":"directional"},
    {"id":"w4","a":"s2","b":"sh","type":"directional"},
    {"id":"w5","a":"s2","b":"r3","type":"delay"},
    {"id":"w6","a":"s1","b":"r2","type":"forbidden"},
    {"id":"w7","a":"s3","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g58',
    name: "Gambit",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"},
    {"id":"p3","x":900,"y":680,"type":"protected","label":"P3"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"r3","type":"directional"},
    {"id":"w4","a":"s1","b":"sh","type":"directional"},
    {"id":"w5","a":"s1","b":"r3","type":"delay"},
    {"id":"w6","a":"s2","b":"p1","type":"directional"},
    {"id":"w7","a":"s3","b":"p2","type":"directional"},
    {"id":"w8","a":"s4","b":"p3","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g59',
    name: "Ridge",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":900,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"sh","type":"directional"},
    {"id":"w4","a":"s1","b":"r2","type":"delay"},
    {"id":"w5","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w6","a":"s3","b":"r2","type":"forbidden"},
    {"id":"w7","a":"s4","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g60',
    name: "Pulse",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":900,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"r3","type":"directional"},
    {"id":"w4","a":"s1","b":"sh","type":"directional"},
    {"id":"w5","a":"s1","b":"r3","type":"delay"},
    {"id":"w6","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w7","a":"s3","b":"p1","type":"directional"},
    {"id":"w8","a":"s4","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g61',
    name: "Threshold",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"sh","type":"directional"},
    {"id":"w3","a":"s1","b":"r2","type":"delay"},
    {"id":"w4","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w5","a":"s3","b":"p1","type":"directional"},
    {"id":"w6","a":"s4","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g62',
    name: "Aperture",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s4","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s4","b":"r2","type":"directional"},
    {"id":"w3","a":"s4","b":"sh","type":"directional"},
    {"id":"w4","a":"s4","b":"r2","type":"delay"},
    {"id":"w5","a":"s1","b":"p1","type":"directional"},
    {"id":"w6","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w7","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g63',
    name: "Echo",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sp","x":420,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"},
    {"id":"p3","x":900,"y":680,"type":"protected","label":"P3"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"r3","type":"directional"},
    {"id":"w4","a":"s3","b":"sh","type":"directional"},
    {"id":"w5","a":"s3","b":"r3","type":"delay"},
    {"id":"w6","a":"s1","b":"p1","type":"directional"},
    {"id":"w7","a":"s2","b":"p2","type":"directional"},
    {"id":"w8","a":"s4","b":"p3","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g64',
    name: "Relay",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"},
    {"id":"p3","x":900,"y":680,"type":"protected","label":"P3"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s2","b":"sh","type":"directional"},
    {"id":"w4","a":"s2","b":"r2","type":"delay"},
    {"id":"w5","a":"s1","b":"p1","type":"directional"},
    {"id":"w6","a":"s3","b":"p2","type":"directional"},
    {"id":"w7","a":"s4","b":"p3","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g65',
    name: "Cinder",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"sh","type":"directional"},
    {"id":"w4","a":"s1","b":"r2","type":"delay"},
    {"id":"w5","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w6","a":"s3","b":"r2","type":"forbidden"},
    {"id":"w7","a":"s4","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g66',
    name: "Vault",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":660,"y":1580,"type":"required","label":"R3"},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"r2","type":"directional"},
    {"id":"w2","a":"s2","b":"r3","type":"directional"},
    {"id":"w3","a":"s2","b":"sh","type":"directional"},
    {"id":"w4","a":"s2","b":"r3","type":"delay"},
    {"id":"w5","a":"s1","b":"p1","type":"directional"},
    {"id":"w6","a":"s3","b":"r3","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g67',
    name: "Specter",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"r1","type":"directional"},
    {"id":"w1","a":"s3","b":"r2","type":"directional"},
    {"id":"w2","a":"s3","b":"sh","type":"directional"},
    {"id":"w3","a":"s3","b":"r2","type":"delay"},
    {"id":"w4","a":"s1","b":"p1","type":"directional"},
    {"id":"w5","a":"s2","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g68',
    name: "Halcyon",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"r2","type":"directional"},
    {"id":"w3","a":"s2","b":"sh","type":"directional"},
    {"id":"w4","a":"s2","b":"r2","type":"delay"},
    {"id":"w5","a":"s1","b":"r2","type":"forbidden"},
    {"id":"w6","a":"s3","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g69',
    name: "Quartz",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"r3","x":900,"y":1580,"type":"required","label":"R3"},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r3"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"},
    {"id":"p3","x":900,"y":680,"type":"protected","label":"P3"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"r3","type":"directional"},
    {"id":"w3","a":"s1","b":"sh","type":"directional"},
    {"id":"w4","a":"s1","b":"r3","type":"delay"},
    {"id":"w5","a":"s2","b":"p1","type":"directional"},
    {"id":"w6","a":"s3","b":"p2","type":"directional"},
    {"id":"w7","a":"s4","b":"p3","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2","r3"]},
  },
  {
    id: 'g70',
    name: "Vector",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s4","b":"r1","type":"directional"},
    {"id":"w1","a":"s4","b":"r2","type":"directional"},
    {"id":"w2","a":"s4","b":"sh","type":"directional"},
    {"id":"w3","a":"s4","b":"r2","type":"delay"},
    {"id":"w4","a":"s1","b":"p1","type":"directional"},
    {"id":"w5","a":"s2","b":"p2","type":"directional"},
    {"id":"w6","a":"s3","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g71',
    name: "Onyx",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":180,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"sh","type":"directional"},
    {"id":"w4","a":"s3","b":"r2","type":"delay"},
    {"id":"w5","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w6","a":"s2","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g72',
    name: "Pylon",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":420,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"sh","x":180,"y":680,"type":"shield","label":"SH","shields":["r2"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"sh","type":"directional"},
    {"id":"w4","a":"s1","b":"r2","type":"delay"},
    {"id":"w5","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w6","a":"s3","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'g73',
    name: "Cascade",
    tier: 'nightmare',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":420,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"core","x":180,"y":1580,"type":"core","label":"CORE","threshold":3},
    {"id":"csp","x":420,"y":1280,"type":"splitter","label":"CSP","splitFactor":3},
    {"id":"csh","x":180,"y":680,"type":"shield","label":"CSH","shields":["core"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"csh","type":"directional"},
    {"id":"w4","a":"s3","b":"csp","type":"directional"},
    {"id":"w5","a":"csp","b":"core","type":"directional"},
    {"id":"w6","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w7","a":"s2","b":"r1","type":"forbidden"},
    {"id":"w8","a":"s4","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"],"coreNodeId":"core"},
  },
  {
    id: 'g74',
    name: "Ledger",
    tier: 'nightmare',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"sp","x":420,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"core","x":660,"y":1580,"type":"core","label":"CORE","threshold":3},
    {"id":"csp","x":420,"y":1280,"type":"splitter","label":"CSP","splitFactor":3},
    {"id":"csh","x":180,"y":680,"type":"shield","label":"CSH","shields":["core"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"csh","type":"directional"},
    {"id":"w3","a":"s2","b":"csp","type":"directional"},
    {"id":"w4","a":"csp","b":"core","type":"directional"},
    {"id":"w5","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w6","a":"s3","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"],"coreNodeId":"core"},
  },
  {
    id: 'g75',
    name: "Mirage",
    tier: 'nightmare',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"core","x":660,"y":1580,"type":"core","label":"CORE","threshold":3},
    {"id":"csp","x":420,"y":1280,"type":"splitter","label":"CSP","splitFactor":3},
    {"id":"csh","x":180,"y":680,"type":"shield","label":"CSH","shields":["core"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"csh","type":"directional"},
    {"id":"w2","a":"s1","b":"csp","type":"directional"},
    {"id":"w3","a":"csp","b":"core","type":"directional"},
    {"id":"w4","a":"s2","b":"r1","type":"forbidden"},
    {"id":"w5","a":"s3","b":"r1","type":"forbidden"},
    {"id":"w6","a":"s4","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"],"coreNodeId":"core"},
  },
  {
    id: 'g76',
    name: "Bastion",
    tier: 'nightmare',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":420,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":660,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"core","x":660,"y":1580,"type":"core","label":"CORE","threshold":3},
    {"id":"csp","x":420,"y":1280,"type":"splitter","label":"CSP","splitFactor":3},
    {"id":"csh","x":180,"y":680,"type":"shield","label":"CSH","shields":["core"]}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s3","b":"csh","type":"directional"},
    {"id":"w4","a":"s3","b":"csp","type":"directional"},
    {"id":"w5","a":"csp","b":"core","type":"directional"},
    {"id":"w6","a":"s1","b":"r2","type":"forbidden"},
    {"id":"w7","a":"s2","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"],"coreNodeId":"core"},
  },
  {
    id: 'g77',
    name: "Cipher",
    tier: 'nightmare',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"sp","x":420,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"core","x":420,"y":1580,"type":"core","label":"CORE","threshold":3},
    {"id":"csp","x":420,"y":1280,"type":"splitter","label":"CSP","splitFactor":3},
    {"id":"csh","x":180,"y":680,"type":"shield","label":"CSH","shields":["core"]}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"csh","type":"directional"},
    {"id":"w4","a":"s1","b":"csp","type":"directional"},
    {"id":"w5","a":"csp","b":"core","type":"directional"},
    {"id":"w6","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w7","a":"s3","b":"r2","type":"forbidden"},
    {"id":"w8","a":"s4","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"],"coreNodeId":"core"},
  },
  {
    id: 'g78',
    name: "Lattice",
    tier: 'nightmare',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2},
    {"id":"sp","x":900,"y":980,"type":"splitter","label":"SP","splitFactor":2},
    {"id":"core","x":660,"y":1580,"type":"core","label":"CORE","threshold":3},
    {"id":"csp","x":420,"y":1280,"type":"splitter","label":"CSP","splitFactor":3},
    {"id":"csh","x":180,"y":680,"type":"shield","label":"CSH","shields":["core"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sp","type":"directional"},
    {"id":"w1","a":"sp","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"csh","type":"directional"},
    {"id":"w3","a":"s2","b":"csp","type":"directional"},
    {"id":"w4","a":"csp","b":"core","type":"directional"},
    {"id":"w5","a":"s1","b":"p1","type":"directional"},
    {"id":"w6","a":"s3","b":"p2","type":"directional"},
    {"id":"w7","a":"s4","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1"],"coreNodeId":"core"},
  },
  {
    id: 'g79',
    name: "Nexus",
    tier: 'nightmare',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"core","x":180,"y":1580,"type":"core","label":"CORE","threshold":3},
    {"id":"csp","x":420,"y":1280,"type":"splitter","label":"CSP","splitFactor":3},
    {"id":"csh","x":180,"y":680,"type":"shield","label":"CSH","shields":["core"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"r2","type":"directional"},
    {"id":"w2","a":"s1","b":"csh","type":"directional"},
    {"id":"w3","a":"s1","b":"csp","type":"directional"},
    {"id":"w4","a":"csp","b":"core","type":"directional"},
    {"id":"w5","a":"s2","b":"r1","type":"forbidden"},
    {"id":"w6","a":"s3","b":"r1","type":"forbidden"},
    {"id":"w7","a":"s4","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"],"coreNodeId":"core"},
  },
  {
    id: 'g80',
    name: "Falter",
    tier: 'nightmare',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":180,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":660,"y":1580,"type":"required","label":"R2"},
    {"id":"core","x":420,"y":1580,"type":"core","label":"CORE","threshold":3},
    {"id":"csp","x":420,"y":1280,"type":"splitter","label":"CSP","splitFactor":3},
    {"id":"csh","x":180,"y":680,"type":"shield","label":"CSH","shields":["core"]},
    {"id":"p1","x":420,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s4","b":"r1","type":"directional"},
    {"id":"w1","a":"s4","b":"r2","type":"directional"},
    {"id":"w2","a":"s4","b":"csh","type":"directional"},
    {"id":"w3","a":"s4","b":"csp","type":"directional"},
    {"id":"w4","a":"csp","b":"core","type":"directional"},
    {"id":"w5","a":"s1","b":"p1","type":"directional"},
    {"id":"w6","a":"s2","b":"r1","type":"forbidden"},
    {"id":"w7","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"],"coreNodeId":"core"},
  }
];
